<template>
    <div id="demo-basic-card">
      <div id="addModuleLoadingDiv" class="vs-con-loading__container">
          <vx-card :title="listing_data.title_en" class="mb-base">
  
              <form @submit="validateListingForm" enctype="multipart/form-data">
  
              <template   slot="actions">
                  <vx-tooltip text="Back to all listing" position="left">
                      <feather-icon @click="redirectToAllListing()" icon="ChevronsLeftIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                  </vx-tooltip>
              </template>
  
              <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input v-validate="'required'" name="title_en" ref="title_en" class="w-full" label="Title (English)" v-model="listing_data.title_en" />
                      <span class="text-danger text-sm" v-show="errors.has('title_en')">{{ errors.first('title_en') }}</span>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input v-validate="'required'" name="title_da" ref="title_da" class="w-full" label="Title (Danish)" v-model="listing_data.title_da" />
                      <span class="text-danger text-sm" v-show="errors.has('title_da')">{{ errors.first('title_da') }}</span>
                  </div>
              </div>
  
              <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                      <span>Descriptioin (English)</span><br>
                      <textarea v-model="listing_data.description_en" class="w-full" name="description_en" id="description_en" cols="30" rows="10" style="border: 1px solid rgba(0, 0, 0, 0.2)"></textarea>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                      <span>Descriptioin (Danish)</span><br>
                      <textarea v-model="listing_data.description_da" class="w-full" name="description_da" id="description_da" cols="30" rows="10" style="border: 1px solid rgba(0, 0, 0, 0.2)"></textarea>
                  </div>
              </div>

              <!-- radio button  -->
              <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <div class="mt-2">
                        <vs-radio v-model="listing_data.url_link" :vs-value="'website'" class="mr-4">Website</vs-radio>
                        <vs-radio v-model="listing_data.url_link" :vs-value="'youtube'" class="mr-4">Youtube</vs-radio>
                    </div>    
                </div>
              </div>
  
              <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input  name="video_url" ref="video_url" class="w-full" label="URL" v-model="listing_data.video_url" />
                      <small style="color:red;">Correct URL format: https://www.youtube.com/watch?v=WdrpQ3k6xmE</small>
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2" >
                      <span>Picture</span><br>
                      <input type="file" name="picture" ref="picture" class="w-full" label="Picture" v-on:change="onFileChange" />
                      <span class="text-danger text-sm" v-show="errors.has('picture')">{{ errors.first('picture') }}</span>
                      <br>
                      <img :src="listing_data.picture">
                  </div>
              </div>
          
              <div class="vx-row">
                  <div class="vx-col  w-full mb-4">
                      Category
                      <treeselect v-model="listing_data.category_id" :multiple="false" :options="categories" />
                  </div>
              </div>
          
  
              <div class="vx-row">
                  <div class="vx-col w-full"  align="right">
                      <br>
                      <!-- <button class="button button-success">Submit</button> -->
                      <vs-button @click="validateListingForm" class="mr-3 mb-2">Update Listing</vs-button>
                  </div>
              </div>
  
              </form>
  
          </vx-card>
      </div>
  
    </div>
  </template>
  
  
  <script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import moduleLearningHub from '@/store/learninghub/moduleLearningHub.js'
  import 'swiper/dist/css/swiper.min.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import vSelect from 'vue-select'
  import Treeselect from '@riophae/vue-treeselect'
    // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  
  export default{
      data() {
          return {
              listing_data: {
                  title_en : null,
                  title_da : null,
                  description_en : null,
                  description_da : null,
                  url_link: '',
                  picture: null,
                  picture_hidden: null,
                  video_url: null,
                  category_id: null,
               
              },
              module_not_found: false,
              categories: [],
             
          }
      },
      components: {
          VuePerfectScrollbar,
          swiper,
          swiperSlide,
          vSelect,
          Treeselect,
      },
      computed: {
      },
      methods: {
       
          redirectToAllListing() {
              this.$router.push("/learninghub").catch(() => {})
          },
          validateListingForm(e) {
              e.preventDefault();
              this.createListingV2();
          },
          onFileChange(e){
              console.log(e.target.files[0]);
              this.listing_data.picture = e.target.files[0];
          },

          createListingV2(){
            

            const id = this.$route.params.id
            console.log('id', id);
                console.log('check type', this.listing_data.url_link);
                if(this.listing_data.url_link === 'website'){
                    console.log('picture : ',this.listing_data.picture);
                    if(this.listing_data.picture === '' || this.listing_data.picture === null){
                        alert("please select an image");
                        return false;
                    }
                }
                if(this.listing_data.url_link === 'youtube'){
                    console.log('enter youtube');
                    console.log('before update :',this.listing_data.picture);
                    this.listing_data.picture = "";
                    this.listing_data.picture_hidden = "";
                    console.log('after update :',this.listing_data.picture);
                }

              let formData = new FormData();
              formData.append('title_en', this.listing_data.title_en);
              formData.append('title_da', this.listing_data.title_da);
              formData.append('description_en', this.listing_data.description_en);
              formData.append('description_da', this.listing_data.description_da);
              formData.append('url_type', this.listing_data.url_link);
              formData.append('picture', this.listing_data.picture);
              formData.append('picture_hidden', this.listing_data.picture_hidden);
              formData.append('video_url', this.listing_data.video_url);
              formData.append('category_id', this.listing_data.category_id);
              formData.append('id', id);
                console.log('update...')
              this.$store.dispatch("learninghubManagement/updateListing", formData)
              .then(res => { 
                  this.$vs.loading.close('#addModuleLoadingDiv > .con-vs-loading')
  
                  this.$vs.notify({
                      time:4000,
                      title:'Success',
                      text: (res.data.status) ? res.data.status : 'Listing updated successfully.',
                      color:'success',
                      iconPack: 'feather',
                      icon:'icon-alert-circle'
                  });
  
                  //this.$router.push("/learninghubcategories/edit/" + res.data.data.id).catch(() => {})
              })
              .catch(err => {
                  this.$vs.loading.close('#addModuleLoadingDiv > .con-vs-loading')
              })
  
  
          },
      },
      created() {

        if(!moduleLearningHub.isRegistered) {
            console.log('is registered not');
            this.$store.registerModule('learninghubManagement', moduleLearningHub)
            moduleLearningHub.isRegistered = true
        }

          

        const id = this.$route.params.id
        this.$store.dispatch("learninghubManagement/getAList", id)
              .then(res => { 

                console.log( res );
                  this.listing_data = res.data
                  this.listing_data.picture_hidden = res.data.picture;
                  this.listing_data.url_link = res.data.url_type;
              })
              .catch(err => {
                   console.error(err) 
        })
  
          this.$store.dispatch("learninghubManagement/fetchCategoriesDD")
              .then(res => { 
                
                  this.categories = res.data
                  
              })
              .catch(err => {
                  // console.error(err) 
              })
      },
  
  }
  </script>  